import { css } from '@emotion/react'
import { Icon } from '@iconify/react'
import { Button, Stack, theme, Typography } from '@nexans/react-ui-kit'

export type BuyCardProps = {
  imageSrc: string
  title: string
  description: string
  buttonText: string
  onBuy: () => void
}

const BuyCard = ({ imageSrc, title, description, buttonText, onBuy }: BuyCardProps) => {
  return (
    <Stack css={styles.buyCard} direction="horizontal">
      <img alt="" css={{ height: '100%' }} src={imageSrc} />
      <Stack css={styles.actionCard} justify="center" px="xl" spacing="md">
        <Typography variant="h4">{title}</Typography>
        <Typography color={theme.colors.red[600]} css={{ marginBottom: 12 }} variant="body2">
          {description}
        </Typography>
        <div>
          <Button icon={<Icon icon="mdi:cart" />} variant="outlined" onClick={onBuy}>
            {buttonText}
          </Button>
        </div>
      </Stack>
    </Stack>
  )
}

const styles = {
  buyCard: css({
    borderRadius: 12,
    borderWidth: 0,
    background: 'linear-gradient(180deg, #FF4A40 0%, #FF7D36 100%)',
    height: 250,
    width: '100%',
    boxShadow: '0 4px 12px 0 rgba(60, 90, 111, 0.16)',
  }),
  actionCard: css({
    borderRadius: 12,
    borderWidth: 0,
    backgroundColor: theme.colors.gray[0],
    height: 250,
    width: '100%',
  }),
}

export default BuyCard
